export default __webpack_public_path__ + "static/sharefomo_scrnsht_small-b7f2e9b279e4c11e81d0a3d2050fa57e.jpg";